angular.module('TetherApp').controller('AccessCodeController', [
    '$window',
    'accessCodeService',
    function (
        $window,
        accessCodeService
    ) {
        let self = this;
        self.accessCode = {};

        self.create = function() {
            accessCodeService.create(this.accessCode)
                .then(onCreate, onError);
        };

        let onCreate = function (data) {
            $window.location.reload();
        };

        self.update = function() {
            accessCodeService.update(this.accessCode)
                .then(onUpdate, onError);
        };

        let onUpdate = function (data) {
            $window.location.reload();
        };

        let onError = function (data) {
            self.errors = data.data.errors;
        };

    }
]);
